import { useMemo } from 'react';
import { bookingValues } from '../initialValues';
import { Booking } from '../../Shared/Types/bookingTypes';

export const useInitialBookingValues = (search: string): Booking =>
  useMemo(() => {
    const searchParams = new URLSearchParams(search);
    const requestedOfferId = Number(searchParams.get('offerId'));

    return Number.isInteger(requestedOfferId) && requestedOfferId > 0
      ? { ...bookingValues, offerId: requestedOfferId }
      : bookingValues;
  }, [search]);
